<!------------ START TEMPLATE ------------>
<template>
  <Modal
    class="holamundo"
    :title="title"
    :active.sync="exibeModal"
    @close="closeModal"
  >
    <table class="table table-bordered">
      <tr v-for="(item, index) in modalSelecionado" :key="index">
        <th class="uppercase">{{ item.coluna }}</th>
        <td>
          <div v-if="item.coluna == 'senha'">******</div>
          <div v-else-if="typeof item[item.coluna] == 'object'">
            <div v-for="(itemaux, index) in item[item.coluna]" :key="index">
              <ul v-if="itemaux">
                <li
                  v-for="(itemCol, index) in Object.keys(itemaux)"
                  :key="index"
                >
                  <div v-if="itemCol.indexOf('id') != 0">
                    <b>{{ itemCol }}:&nbsp;</b>
                    <span v-if="itemCol == 'valor' || itemCol == 'preco'">{{
                      itemaux[itemCol] | currency
                    }}</span>
                    <span v-if="isDate(itemaux[itemCol])">{{
                      formatDatetime(itemaux[itemCol])
                    }}</span>
                    <span v-else>{{ itemaux[itemCol] }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-else-if="item.coluna == 'Valor' || item.coluna == 'ValorPromocao'"
          >
            {{ item[item.coluna] | currency }}
          </div>
          <div v-else-if="item.coluna.indexOf('data') == 0">
            {{ formataData(item[item.coluna]) }}
          </div>
          <div v-else-if="item.coluna == 'logo' || item.coluna == 'foto'">
            <img
              v-if="item[item.coluna]"
              :src="showPicture(item[item.coluna])"
              width="150px"
            />
            <img
              v-else
              width="150px"
              src="https://simplesbucket.s3.amazonaws.com/reusar/sem-foto.jpg"
            />
          </div>
          <div v-else>{{ formataTexto(item[item.coluna]) }}</div>
        </td>
      </tr>
    </table>
  </Modal>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import moment from 'moment';
import Modal from '../components/Modal.vue';

export default {
  components: {
    Modal,
  },
  props: ['modalSelecionado', 'popupActive', 'title'],
  watch: {
    popupActive: function (newValue) {
      this.exibeModal = newValue;
    },
  },
  data() {
    return {
      exibeModal: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    showPicture(foto) {
      return `https://bboneapp.s3.amazonaws.com/imgsADM/${foto}`;
    },
    formataData(data) {
      // formats data received from API
      var formattedData = moment(data).format('DD/MM/YYYY');
      return formattedData;
    },
    formataTexto(texto) {
      if (Number.isInteger(texto)) return texto;
      if (texto == true) return 'sim';
      if (texto == false) return 'não';
      return texto;
    },
    isDate(item) {
      if (item instanceof Date) {
        return !Number.isNaN(item.getTime());
      }

      if (typeof item !== 'string') return false;

      const value = item.trim();
      if (!value) return false;

      const acceptedFormats = [
        moment.ISO_8601,
        'YYYY-MM-DD',
        'YYYY-MM-DD HH:mm:ss',
        'DD/MM/YYYY',
        'DD/MM/YYYY HH:mm:ss',
      ];

      return moment(value, acceptedFormats, true).isValid();
    },
    formatDatetime(item) {
      console.log(item);
      return moment(item).format('DD/MM/YYYY HH:mm:ss');
    },
  },
};
</script>
<!------------ END SCRIPT ------------>
